(function () {

    const accMinValue = 1;
    const GRAVITY_VALUE = 9.8;

    const RUNNING_DURATION = 8000;
    const RUNNING_INTERVAL = 1000;
    const MAX_ARR_LENGTH = 100000;

    const startButton = document.getElementById('startButton');
    const startContainer = document.getElementById('startContainer');
    const countContainer = document.getElementById('countContainer');
    const distanceContainer = document.getElementById('distanceContainer');
    const speedDomElement = document.getElementById('speedValue');
    const avSpeedValue = document.getElementById('avSpeedValue');
    const actionBox = document.getElementById('actionBox');
    const summaryBox = document.getElementById('summaryBox');
    const buttonElement = document.getElementById('nextButton');

    const xCords = document.getElementById('xCords');
    const yCords = document.getElementById('yCords');
    const zCords = document.getElementById('zCords');

    var runningStarted = false;

    let podo_stepSize =  70,
        podo_weight = 70,
        podo_step =  0,
        podo_speed = 0,
        podo_calory = 0,
        isGPSEnabled = false;

    let activatePodo = 1;

    function summation(elements){
        return elements.reduce((value, sum) => {
            sum += value;
            return sum;
        }, 0)
    }

    function Running() {
    }

    Running.prototype.init = function () {

        var _this = this;

        var lastTimestamp;
        this.speedAvArr = [];
        this.speedAvPerSecond = [];

        this.options = {
            stepSize: 70,
            requiredSpeed: 15
        };

        // var gui = new dat.GUI();
        //
        // gui.add(this.options, 'stepSize', 30, 150);
        // gui.add(this.options, 'requiredSpeed', 8, 15);
        this.podo = new window.Pedometer();
        this.podo.setCountStep(Math.round(podo_step));
        this.podo.setWeight(Math.round(podo_weight));
        this.podo.setStepSize(Math.round(this.options.stepSize));
        this.podo.setMeanSpeed(Math.round(podo_speed*1000.)/1000.);
        this.podo.setCalory(Math.round(podo_calory*1000.)/1000.);
        this.podo.setIsGPSEnabled(Boolean(isGPSEnabled));

        this.deviceMotionEventHandler = function(event) {

            _this.podo.setStepSize(Math.round(_this.options.stepSize));

            this.hasDeviceMotion = 'ondevicemotion' in window;
            if(!this.hasDeviceMotion){
                window.permissionDeniedEvent = new Event('permissionDeniedMicEvent');
                window.dispatchEvent(permissionDeniedEvent);
            }
            if (true) {
                if ((_this.podo.acc_norm.length < 2) || (_this.podo.stepArr.length < 2)) {
                    //$("#gamma-angle").html(Math.round(2/(event.interval/1000)));
                    _this.podo.createTable(125);
                } else {

                    window.norm = _this.podo.computeNorm(Math.abs(event.accelerationIncludingGravity.x), Math.abs(event.accelerationIncludingGravity.y), Math.abs(event.accelerationIncludingGravity.z));

                    _this.podo.acc_norm.push(window.norm);

                    _this.podo.update();

                    _this.podo.onStep(_this.podo.acc_norm);
                    const currentSpeed = _this.podo.onSpeed();
                    _this.podo.onCalory();

                    podo_step = _this.podo.countStep;
                    podo_speed = _this.podo.meanSpeed;
                    podo_calory = _this.podo.calory;

                    if(!runningStarted) return;

                    if(!isNaN(currentSpeed)) {

                        document.getElementById('speedValue').innerHTML = (currentSpeed * 3.6).toFixed(0) < 10 ? '0' + (currentSpeed * 3.6).toFixed(0) : (currentSpeed * 3.6).toFixed(0) ;

                        if(currentSpeed > 0) {
                            document.querySelector('#afterFirstActionCorrect').style.display = 'block';
                        }

                        if(currentSpeed * 3.6 > _this.options.requiredSpeed){
                            var text = document.querySelector('.text-info');
                            text.innerHTML = "Herzliche Gratulation! <br> Du hast es geschafft. "
                            var button = document.querySelector('#nextButton');
                            button.removeAttribute('disabled');

                            $('.box__background-width').css('left', '100%');
                            document.getElementById('speedValue').innerHTML = 15;
                            runningStarted = false;
                        }

                        _this.updateStepSizeRegardingToCurrentSpeedValue((currentSpeed * 3.6).toFixed(1));
                        $('.box__background-width').css('left', (Math.min(100, getCurrentPercentValue(currentSpeed * 3.6)) + '%'));

                    }

                    //0 - 5km/h - 70, 5 - 8km/h - 85, 8 - 11km/h - 100, 11 - 15km/h - 120


                }
            }

        };

        window.addEventListener('devicemotion', _this.deviceMotionEventHandler, false);


        function getCurrentPercentValue(currentValue){

            const maxValue = _this.options.requiredSpeed;
            return currentValue*100/maxValue;

        }

        _this.startRunning();

    };

    Running.prototype.updateStepSizeRegardingToCurrentSpeedValue = function(speedValue){

        var newSpeedVal;

        if(speedValue < 5){
            newSpeedVal = 70;
        } else if(speedValue >=5 && speedValue < 8){
            newSpeedVal = 80;
        } else if(speedValue >= 8 && speedValue < 11){
            newSpeedVal = 100;
        } else if(speedValue >= 11){
            newSpeedVal = 120;
        }

        this.options.stepSize = newSpeedVal;

    };

    Running.prototype.reduceResultsInArray = function(array){
        if(array.length < MAX_ARR_LENGTH) return array;

        let sumValue = 0;

        for( var i = 0; i < array.length; i++ ){
            sumValue += array[i];
        }

        const currentAccAv = sumValue/array.length;
        return [currentAccAv];
    };

    Running.prototype.startRunning = function (countDomElement, speedDomElement) {

        var _this = this;
        var currentValue = 0;
        this.speedAvPerSecond = [];

        // startButton.style.display = 'none';
        // startContainer.style.display = 'none';
        // summaryBox.style.display = 'none';
        // actionBox.style.display = 'block';

        activatePodo = 1;

        runningStarted = true;

        // return new Promise((resolve, reject) => {
        //
        //     const countInterval = setInterval( () => {
        //
        //         const currentAvValue = _this.getCurrentAvSpeedFromArr(_this.speedAvPerSecond);
        //         const distanceValue = _this.getCurrentAvSpeed() * currentValue
        //
        //         if (currentAvValue > 10 || distanceValue > 12) return (() => {
        //             clearInterval(countInterval);
        //             actionBox.style.display = 'none';
        //             resolve();
        //         })();
        //
        //         currentValue = currentValue + RUNNING_INTERVAL/1000;
        //         countDomElement.innerHTML = currentValue;
        //         distanceContainer.innerHTML = distanceValue.toFixed(2) + ' m' ;
        //         speedDomElement.innerHTML = _this.getCurrentAvSpeedFromArr(_this.speedAvPerSecond);
        //
        //         _this.speedAvPerSecond = [];
        //
        //     }, RUNNING_INTERVAL);
        //
        // })
    };

    Running.prototype.destroy = function(){

        window.removeEventListener('devicemotion', this.deviceMotionEventHandler);

    };

    Running.prototype.getCurrentAvSpeed = function(time){


        if(!this.speedAvArr.length) return 0;

        let sumValue = 0;

        for( var i = 0; i < this.speedAvArr.length; i++ ){
            sumValue += this.speedAvArr[i];
        }

        const currentAccAv = sumValue/this.speedAvArr.length;

        const number = currentAccAv * 3.6 * 100000;
        return Math.abs(number).toFixed(2);

    };

    Running.prototype.getCurrentAvSpeedFromArr = function(array, time){

        if(!array.length) return 0;

        let sumValue = 0;

        for( var i = 0; i < array.length; i++ ){
            sumValue += array[i];
        }

        const currentAccAv = sumValue/array.length;

        const number = currentAccAv * 3.6 * 100000;
        return Math.abs(number).toFixed(2);

    };

    window.Running = Running;

})();
